import nodemailer from "nodemailer";

export const transporter = nodemailer.createTransport({
    host: process.env.SMTP_HOST,
    port: Number(process.env.SMTP_PORT),
    secure: true,
    auth: {
        user: process.env.SMTP_USER,
        pass: process.env.SMTP_PASS,
    },
});

export async function sendMail(options: {
    to: string;
    subject: string;
    html: string;
    replyTo?: string;
    attachments?: { filename: string; content: Buffer; contentType?: string }[];
}) {
    return transporter.sendMail({
        from: `"Website" <${process.env.SMTP_USER}>`,
        to: options.to,
        replyTo: options.replyTo,
        subject: options.subject,
        html: options.html,
        attachments: options.attachments,
    });
}